import Loader, { PARSERS } from '../loader.mjs';
import { getAIInput } from '../ai/let-ai-decide/let-ai-decide.utils.ts';
import { I18n } from '../helpers/i18n.mjs';

export async function getModuleData(appName, moduleName, version) {
	version = version || 'latest';
	const data = await Loader.load(`api://imt/apps/${encodeURIComponent(appName)}/${version}`, {}, PARSERS.MANIFEST);

	const app = data.app;
	const modules = [].concat(app.actions, app.transformers, app.searches).filter((x) => !!x);

	return {
		package: data.app,
		config: modules.find((x) => x.name === moduleName) || {},
	};
}

export function getModuleConfigForm({
	moduleData,
	config = {},
	toolConfig = { name: null, description: null },
	inputs = [],
	options = {},
}) {
	const form = new window.Formula('Parameters');

	form.config = moduleData.config.parameters;
	form.form.meta.module = { ...{ restore: config?.metadata?.restore || {} }, ...moduleData };
	// form.form.tree = false;
	form.form.options = options;

	const manifestV2 = (moduleData.package.manifest?.version ?? 0) >= 2;

	const domain = form.domains.set('expect', moduleData.config.expect, config.mapper || {});
	domain.priority = 1;
	domain.defaults.coder = true;
	domain.defaults.mappable = manifestV2;
	domain.defaults.erasable = manifestV2;
	domain.defaults.showErasePill = true;
	domain.dynamic = true;

	form.values = config.parameters;

	const aiagentDomain = form.domains.set(
		'aiagent',
		[
			{
				name: 'name',
				type: 'text',
				label: I18n.l('common.name'),
				required: true,
				validate: {
					max: 120,
				},
				help: I18n.l('aiAgentTools.nameHelp'),
			},
			{
				name: 'description',
				type: 'text',
				label: I18n.l('scenarioList.description'),
				required: true,
				validate: {
					max: 240,
				},
				multiline: true,
				help: I18n.l('aiAgentTools.descriptionHelp'),
			},
			{
				type: 'separator',
			},
		],
		{
			name: toolConfig.name || `${moduleData.package.label} ${moduleData.config.label}`,
			description: toolConfig.description || moduleData.config.description,
		},
	);
	aiagentDomain.defaults.coder = false;
	aiagentDomain.defaults.mappable = false;
	aiagentDomain.priority = -1;

	const formInputs = form.form.meta.imlOptions.variables?.find((x) => x.category === 'scenario_inputs') || {};
	formInputs.items = [];

	if (inputs?.length > 0) {
		const setInput = (spec, patentSpecName = undefined) => {
			const inputPath = patentSpecName ? `${patentSpecName}.${spec.name}` : spec.name;
			formInputs.items[inputPath] = getAIInput(inputPath);

			if (spec.spec) {
				if (Array.isArray(spec.spec)) {
					spec.spec.forEach((childSpec) => {
						setInput(childSpec, inputPath);
					});
				} else if (typeof spec.spec === 'object') {
					setInput(spec.spec, inputPath);
				}
			}
		};

		inputs.forEach((input) => {
			setInput(input);
		});
	}

	form.build((err, f) => {
		if (err) {
			console.error(err);
		}
	});

	form.form.enableLetAIDecide();

	return form;
}

export function getModuleConfigFormValue(form, moduleData) {
	const pkg = moduleData.package;
	const moduleName = moduleData.config.name;

	return {
		parameters: form.toJSON(),
		mapper: form.toJSON('expect'),
		metadata: {
			restore: form.save(),
			parameters: form.toConfig('default', true),
			expect: form.toConfig('expect', true),
			advanced: form.advancedParametersVisible ? true : undefined,
		},
		module: `${pkg.name}:${moduleName}`,
		version: parseInt(pkg.version),
	};
}
